/** @enum {string} Customer order fulfillment (API payloads). */
export const FULFILLMENT_MODE = Object.freeze({
    NO_SHIPMENT: "no_shipment",
    SHIP_FROM_AGENT_WAREHOUSE: "ship_from_agent_warehouse",
    SHIP_FROM_SUPPLIER: "ship_from_supplier",
    SHIP_FROM_SUPPLIER_WAREHOUSE: "ship_from_supplier_warehouse",
});
